import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _circle;

import React from 'react';
import styled from 'styled-components';
var Marker = styled.svg(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: 27px;\n  box-shadow: 0 0 4px 0 rgba(10, 16, 30, 0.1);\n  background-color: ", ";\n  padding: 4px 7px;\n  font-weight: bold;\n  position: absolute;\n  transform: translate(-50%, -50%);\n  display: flex;\n  font-size: 13px;\n  cursor: pointer;\n\n  & > circle {\n    fill: ", "\n  }\n"])), function (props) {
  return props.active ? props.theme.colors.dark : props.theme.colors.light;
}, function (props) {
  if (props.isOffline) {
    return '#d13042';
  }

  if (props.circleFillColor) {
    return props.theme.colors[props.circleFillColor];
  }

  return null;
});

function LabelMarker(_ref) {
  var data = _ref.data,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label,
      _ref$isOffline = _ref.isOffline,
      isOffline = _ref$isOffline === void 0 ? false : _ref$isOffline,
      _ref$isActive = _ref.isActive,
      isActive = _ref$isActive === void 0 ? false : _ref$isActive,
      _ref$statusColor = _ref.statusColor,
      statusColor = _ref$statusColor === void 0 ? null : _ref$statusColor,
      _ref$onClick = _ref.onClick,
      _onClick = _ref$onClick === void 0 ? function (e) {
    return e;
  } : _ref$onClick,
      _ref$onBlur = _ref.onBlur,
      onBlur = _ref$onBlur === void 0 ? function (e) {
    return e;
  } : _ref$onBlur;

  return /*#__PURE__*/React.createElement(Marker, {
    height: "30",
    active: isActive,
    width: label.length * 10,
    onClick: function onClick() {
      return _onClick(data);
    },
    onBlur: onBlur,
    circleFillColor: statusColor
  }, (isOffline || statusColor) && (_circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: "4",
    cx: "5",
    cy: "10"
  }))), /*#__PURE__*/React.createElement("text", {
    x: isOffline || statusColor ? '13' : '5',
    y: "15",
    fill: isActive ? 'white' : 'black'
  }, label));
}

export default LabelMarker;